var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about container",
    attrs: {
      "id": "million-bit-about"
    }
  }, [_c('h3', [_vm._v("About")]), _vm._v(" "), _c('p', [_vm._v("\n        Welcome to the Million Bit Homepage, where nostalgia meets blockchain innovation! Inspired by the original Million Dollar Homepage, we've brought the fun to Ethereum on Base for Onchain Summer.\n        "), _c('br'), _c('br'), _vm._v("\n        Be forever immortalized on the blockchain. Use ETH to upload your image and a link, to secure your spot on the homepage. At the end of onchain summer, the resulting image will be minted.\n        "), _c('br'), _c('br'), _vm._v("\n        Share your contribution and make sure to join our community on "), _c('a', {
    attrs: {
      "href": _vm.appData().telegram,
      "target": "_blank"
    }
  }, [_vm._v("Telegram")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": _vm.appData().twitter,
      "target": "_blank"
    }
  }, [_vm._v("Twitter")]), _vm._v(" for updates.\n    ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Roadmap")]), _vm._v(" "), _vm._m(0)])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("✅ Homepage launch [done]")]), _vm._v(" "), _c('li', [_vm._v("✅ Affiliate program [done]")]), _vm._v(" "), _c('li', [_vm._v("✅ NFT launch to pixel owners [done]")]), _vm._v(" "), _c('li', [_vm._v("⏳ Community building (ongoing)")]), _vm._v(" "), _c('li', [_vm._v("🔜 Token launch (coming soon)")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d3af938a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/About.vue
// module id = qA7t
// module chunks = 2